<template>
    <div class="page flex-col" ref="page">
      <newHeader nowNav="index"></newHeader>
        <div class="apng_box">
            <img src="./assets/img/yannuo.gif" class="index-video" />
          <!-- <video class="index-video" autoplay muted
            @ended="handleVideoEnded"
            ref="videoPlayer" >
            <source src="./assets/img/logo_index.mp4" type="video/mp4">
          </video> -->
        </div>
        <div class="index-img-01">
          <img src="./assets/img/index-image-01.jpg" />
        </div>
        <div class="index-img-02">
          <img src="./assets/img/index-image-02.jpg" />
        </div>
        <div class="index-img-03">
          <img src="./assets/img/index-image-03.jpg" />
        </div>
        <newFooter></newFooter>
    </div>
  
</template>
<script>
import newHeader from '../../components/header.vue'
import newFooter from '../../components/footer.vue'
export default {
  components: {
    newHeader,
    newFooter
  },
  data() {
    return {
      // headerTimer: null,
    };
  },
  mounted() {
    // this.headerTimer = setInterval(() => {
    //     const scrollContainer = this.$refs.page
    //     console.log(this.$refs)
    //     if (scrollContainer) {
    //       const scrollTop = scrollContainer.scrollTop;
    //       console.log(scrollTop)
    //     }
    //   }, 1000);
  },
  methods: {
    // 处理视频播放结束事件
    handleVideoEnded() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.pause();
    }
  }
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />